<template>
    <ui-card-toggle
        design="brightness"
        set-status
        :shadow="4"
        :open="true"
    >
        <template #title>
            <div class="title-enterprise">
                <em class="fal fa-building" />
                <span>Dados do Empreendimento</span>
            </div>
        </template>

        <template #content>
            <div class="text-select-teams">
                <span>Selecione as <span class="teams">Equipes</span> que poderão visualizar os dados do empreendimento.</span>
            </div>


            <div class="content-products-enterprise">
                olamundo
            </div>

            <div class="footer-products-enterprise">
                <div class="numbers-selected">
                    <span class="number">02 equipes</span> <span>selecionadas</span>
                </div>

                <ui-button design="success mw-60 sm">Salvar</ui-button>
            </div>
        </template>
    </ui-card-toggle>
</template>

<script>
import { uiButton } from '@/components/ui/buttons';
import { uiCardToggle } from '@/components/ui/cards';
export default {
    name: 'ui-permissions-enterprise',

    components: {
        uiCardToggle,
        uiButton
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>